import { createSlice } from "@reduxjs/toolkit";
import { FacultyResponse, SpecialityResponse } from "../../models/dtos";
import { RootState } from "../../store";

const initialState = {
  filters: {
    faculties: [] as FacultyResponse[],
    specialities: [] as SpecialityResponse[],
  },
};

const plansSlice = createSlice({
  name: "plans",
  initialState,
  reducers: {
    setSelectedFaculties: (state, action) => {
      state.filters.faculties = action.payload;
    },
    setSelectedSpecialities: (state, action) => {
      state.filters.specialities = action.payload;
    },
    clearPlansFilters: (state) => {
      state.filters = initialState.filters;
    },
  },
});

export const { setSelectedFaculties, setSelectedSpecialities, clearPlansFilters } = plansSlice.actions;
export const getSelectedFaculties = (state: RootState) => state.plans.filters.faculties;
export const getSelectedSpecialities = (state: RootState) => state.plans.filters.specialities;

export const getPlansFilters = (state: RootState) => state.plans.filters;

export const getPlansFiltersCount = (state: RootState) => {
  return state.plans.filters.faculties.length + state.plans.filters.specialities.length;
};

export default plansSlice.reducer;
